export default "__VITE_ASSET__CQOqiSOJ__"